<template>
    <b-overlay :show="loading" rounded="sm">
    <div>
        <b-modal id="modal-customer-user" header-class="p-0" footer-class="d-flex justify-content-center border-0"
            content-class="custom-model-wrap" @ok="handleOk">
            <template #modal-header="{ cancel }">
                <div class="title-block text-center p-2">
                    {{
                        `${customer && customer.name + ' - '}${userModel.id ? $translate('edit_contact') :
                            $translate('new_contact')
                            }`
                    }}
                </div>
                <button id="cancel-label-btn" class="close" @click="cancel()">x</button>
            </template>
            <template #default>
                <b-form ref="contactForm" @submit.stop.prevent="handleSubmit">
                    <b-row v-if="!isPasswordViewOnly">
                        <b-col cols="12">
                            <label class="mb-3"><strong>{{ $translate('email') }}<span class="red">{{
                                userModel.is_blacklisted
                                ? '' : '*'
                            }}</span></strong></label>
                            <b-form-input id="input-email" v-model="displayEmail" type="email"
                                :placeholder="$translate('enter_email')"
                                :required="isEmailViewOnly || !userModel.is_blacklisted"
                                v-custom-validation="(isEmailViewOnly || !userModel.is_blacklisted) ? $textRequired() : ''"
                                :disabled="!isEmailViewOnly && !!userModel.id"></b-form-input>
                        </b-col>
                        <b-col class="mt-3" cols="12" v-if="!isEmailViewOnly">
                            <div class="d-flex align-items-center justify-content-end flex-row-reverse gap-2">
                                <label for="input-is_blacklisted" class="mt-0 mt-md-2"><strong>{{
                                    $translate('customer_portal_access') }}</strong></label>
                                <div class="form-check me-2">
                                    <label class="form-check-label">
                                        <b-form-checkbox id="input-is_blacklisted" v-model="is_blacklisted"
                                            name="input-is_blacklisted" :value="false" :unchecked-value="true"
                                            :disabled="isDummyEmail">
                                        </b-form-checkbox>
                                        <i class="input-helper"></i>
                                    </label>
                                </div>
                            </div>
                        </b-col>
                        <b-col class="mt-3" cols="12" v-if="!isEmailViewOnly">
                            <label class="mb-3"><strong>{{ $translate('phone') }}</strong></label>

                            <b-form-input id="input-phone" v-model="userModel.phone" type="number"
                                :placeholder="$translate('enter_phone')"></b-form-input>
                        </b-col>
                        <b-col class="mt-3" cols="12" v-if="!isEmailViewOnly">
                            <label class="mb-3"><strong>{{ $translate('first_name') }}<span
                                        class="red">*</span></strong></label>
                            <b-form-input id="input-2" v-model="userModel.first_name"
                                :placeholder="$translate('enter_first_name')" required></b-form-input>
                        </b-col>
                        <b-col class="mt-3" cols="12" v-if="!isEmailViewOnly">
                            <label class="mb-3"><strong>{{ $translate('last_name') }}<span
                                        class="red">*</span></strong></label>
                            <b-form-input id="input-last-name" v-model="userModel.last_name"
                                :placeholder="$translate('enter_last_name')" required></b-form-input>
                        </b-col>
                        <b-col class="mt-3" cols="12" v-if="!isEmailViewOnly">
                            <label class="mb-3"><strong>{{ $translate('dob') }}</strong></label>
                            <b-form-input id="input-last-name" :max="dobCalender" type="date" v-model="userModel.dob" ></b-form-input>
                        </b-col>
                        <b-col class="mt-3" cols="12" v-if="!isEmailViewOnly">
                            <label class="mb-3"><strong>{{ $translate('position') }}</strong></label>
                            <b-form-input id="input-position" v-model="userModel.position"
                                :placeholder="$translate('enter_position')"></b-form-input>
                        </b-col>
                        <b-col class="mt-3" cols="12" v-if="!isEmailViewOnly">
                            <label class="mb-3"><strong>{{ $translate('remarks') }}</strong></label>
                            <b-form-textarea id="input-remarks" v-model="userModel.remarks"
                                :placeholder="$translate('enter_remarks')" rows="3" max-rows="6"></b-form-textarea>
                        </b-col>
                        <!-- <b-col cols="12" md="6" class="mt-4" v-if="!isEmailViewOnly">
                            <div class="form-check">
                              <label class="form-check-label lh-base">
                                <input
                                  type="checkbox"
                                 
                                  class="form-check-input top-2"
                                  id="checkbox-model.is_blacklisted"
                                  v-model="userModel.is_blacklisted"
                                  name="checkbox-model.is_blacklisted"
                                  :value="1"
                                  :unchecked-value="false"
                                />&nbsp;&nbsp;
                                {{ $translate("disable") }}
                                <i class="input-helper"></i>
                              </label>
                            </div>
                          </b-col> -->
                          <b-col class="mt-3" cols="12" v-if="!isEmailViewOnly">
                            <div class="d-flex align-items-center justify-content-end flex-row-reverse gap-2">
                                <label for="input-disable" class="mt-0 mt-md-2"><strong>{{
                                    $translate('disable') }}</strong></label>
                                <div class="form-check me-2">
                                    <label class="form-check-label">
                                        <b-form-checkbox id="input-disable"  v-model="userModel.is_blacklisted"
                                            name="input-disable" :value="1" :unchecked-value="false">
                                        </b-form-checkbox>
                                        <i class="input-helper"></i>
                                    </label>
                                </div>
                            </div>
                        </b-col>
                      
                                    
                                 
                        <b-col class="mt-3" cols="12" v-if="!isEmailViewOnly">
                            <div class="d-flex align-items-center justify-content-end flex-row-reverse gap-2">
                                <label for="input-notification" class="mt-0 mt-md-2"><strong>{{
                                    $translate('notifications') }}</strong></label>
                                <div class="form-check me-2">
                                    <label class="form-check-label">
                                        <b-form-checkbox id="input-notification" v-model="notification"
                                            name="input-notification" :unchecked-value="false">
                                        </b-form-checkbox>
                                        <i class="input-helper"></i>
                                    </label>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-card-text v-if="isPasswordViewOnly">
                        <div>
                          <b-overlay :show="password_updating" rounded="sm">
                            <b-form @submit.prevent="updateEmail()" data-vv-scope="email">
                              <b-row>
                                <b-col md="12" cols="12">
                                  <label class="mb-3 mt-3" label-for="input-new-password"><strong>{{ $translate('new_password')
                                  }}</strong></label>
                                  <b-input-group class="password-field-container">
                                  <b-form-input required id="input-new-password" :type="showNewPassword ? 'text' : 'password'" v-custom-validation="$textRequired()"
                                      v-model="reset_password" @input="validatePassword">
                                  </b-form-input>
                                  <b-input-group-append class="eye-btn">
                                      <i @click="showNewPassword = !showNewPassword"
                                          :class="showNewPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                  
                                      </b-input-group-append>
                                  </b-input-group>
                                  <!-- <p class="muted-text">{{ $translate('password_pattern') }}</p> -->
                                  <b-form-invalid-feedback v-if="reset_password?.length > 0" class="row" style="display:flex !important;">
                                    <span class="col-md-6" :style="{ color: hasUppercase ? 'green' : 'red' }">
                                    <i :class="hasUppercase? 'fa fa-check': 'fa fa-x'"></i>
                                    one uppercase character
                                    </span>
                                    <span class="col-md-6" :style="{ color: hasLowercase ? 'green' : 'red' }">
                                    <i :class="hasLowercase? 'fa fa-check': 'fa fa-x'"></i>
                                    one lowercase character
                                    </span>
                                    <span class="col-md-6" :style="{ color: hasSpecialCharacter ? 'green' : 'red' }">
                                    <i :class="hasSpecialCharacter? 'fa fa-check': 'fa fa-x'"></i>
                                    one special character
                                    </span>
                                    <span class="col-md-6" :style="{ color: reset_password?.length >= min_password_length ? 'green' : 'red' }">
                                    <i :class="reset_password?.length >= min_password_length? 'fa fa-check': 'fa fa-x'"></i>
                                    {{ min_password_length }} characters minimum
                                    </span>
                                    <span class="col-md-6" :style="{ color: hasNumber ? 'green' : 'red' }">
                                    <i :class="hasNumber? 'fa fa-check': 'fa fa-x'"></i>
                                    one number
                                    </span>
                                </b-form-invalid-feedback>
                              </b-col>
                  
                               
                              </b-row>
                            </b-form>
                          </b-overlay>
                        </div>
                      </b-card-text>
                </b-form>
            </template>
            <template #modal-footer="{ ok, cancel }">
               
                <b-button id="change-email-btn" class="test-change-email-btn" v-if="!!userModel.id && hasPermissionUpdate &&!isPasswordViewOnly  " size="fw" variant="info"
                    @click="isEmailViewOnly = !isEmailViewOnly">
                    {{ isEmailViewOnly ? $cancelLabel() : $translate('change_email') }}
                </b-button>
               
                    <b-button id="reset-passeord-admin-btn"   v-if="!!userModel.id && hasPermissionUpdate && !isEmailViewOnly" 
                      size="fw"
                      variant="info"
                     
                      @click="isPasswordViewOnly = !isPasswordViewOnly"
                      class="float-right test-reset-password-admin-btn"
                      >
                        {{ isPasswordViewOnly ? $cancelLabel() :$translate("reset_password_admin") }}
                      </b-button>
                 
                <b-button id="submit-form-btn" class="test-submit-form-btn" :disabled="loading" variant="info" size="fw" v-if="(!!userModel.id && hasPermissionUpdate &&!isPasswordViewOnly) ||
                    (!userModel.id && hasPermissionCreate &&!isPasswordViewOnly)
                    " @click="ok()">
                    {{
                        submitLabel
                    }}
                </b-button>
                <b-button id="delete-form-btn" class="test-delete-form-btn"  size="fw" v-if="!isEmailViewOnly &&  
                        allowDeletion &&
                        !!userModel.id &&
                        hasPermissionDelete && !isPasswordViewOnly
                        " variant="delete-button" @click="deleteUser(userModel.id)">
                    {{ $deleteLabel() }}
                </b-button>
                <b-button id="cancel-form-btn" class="test-cancel-form-btn"  size="fw" variant="info" @click="
                    isEmailViewOnly = false
                cancel()
                    " v-if="!isEmailViewOnly && !isPasswordViewOnly ">
                    {{ $cancelLabel() }}
                </b-button>
            
            <b-button v-if="isPasswordViewOnly && hasPermissionUpdate && !isEmailViewOnly"
                                    size="fw"
                                    variant="info"
                                    id="reset-password-admin-form-btn"  
                                    @click="updatePassword()"
                                    class="float-right test-reset-password-admin-form-btn"
                                    :disabled="(!(hasNumber && hasUppercase && hasLowercase && hasSpecialCharacter) ? true : false)"
                                    >{{
                                      $translate("reset_password_admin")
                                    }}</b-button
                                  >
            </template>
        </b-modal>
        <div class="flex justify-content-between">
            <div class="text-left">
                <strong>{{ (customer.name) ? `${$translate('customer_name')}: ${customer.name}` : '' }}</strong>
            </div>
            <div class="text-end">
                <b-button id="add-contact-btn" class="test-add-contact-btn" @click="viewCustomer()" variant="info" v-if="hasPermissionCreate">{{ $translate('add_contact')
            }}</b-button>
            </div>
        </div>
        <b-col class="page-block"><strong> {{ $translate('page') }}: {{ currentPage }} {{ $translate('of') }}
                {{ Math.ceil(rows / itemsPerPage) }} {{ $translate('total') }}:
                {{ rows }}</strong></b-col>
        <b-col class="overflow-auto w-100 mt-4">
            <b-table hover :fields="fields" :items="contacts" :per-page="itemsPerPage" responsive
                :current-page="currentPage">
                <template #cell(id)="{ item }">
                    <b-button  variant="pink-button" class="mr-2 test-view-item-btn" @click="viewCustomer(item)" v-if="hasPermissionDelete">
                        <img src="@/assets/images/icon/view.svg" />
                    </b-button>
                </template>
            </b-table>
        </b-col>

        <b-row>
            <b-col>
                <b-pagination class="float-right mt-4" v-model="currentPage" :total-rows="rows"
                    :next-text="$translate('next')" :prev-text="$translate('previous')" :per-page="itemsPerPage"
                    aria-controls="roleTable" pills align="center"></b-pagination>
            </b-col>
        </b-row>
    </div>
    </b-overlay>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import moment from 'moment'
//const dummyEmailSuffix = 'dummy@oms.innovate10x.com'
const userModel = Object.freeze({
    first_name: null,
    last_name: null,
    phone: null,
    id: null,
    is_blacklisted:1,
    notification:0,
    remarks: null,
})
export default {
    name: 'customers-users',
    mixins: [popupMixins, permissionsMixins],
    data() {
        return {
            userModel: {},
            loading: false,
            settings: {},
            isEmailViewOnly: false,
            isPasswordViewOnly : false,
            itemsPerPage: 15,
            currentPage: 1,
            showNewPassword: false,
            reset_password : "",
            password_updating : false,
            hasNumber: false,
            hasUppercase: false,
            hasLowercase: false,
            hasSpecialCharacter: false,
        }
    },

    props: {
        allowDeletion: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        submitLabel() {
            if (this.loading && this.userModel.id) {
                return this.$translate('updating')
            } else if (this.loading) {
                return this.$translate('creating')
            } else if (this.userModel.id) {
                return this.$updateLabel()
            } else {
                return this.$createLabel()
            }
        },
        rows() {
            return this.contacts.length
        },
        fields() {
            const { dummyEmailSuffix } = this
            return [
                { label: this.$translate('actions'), key: 'id' },
                { label: this.$translate('first_name'), key: 'first_name' },
                { label: this.$translate('last_name'), key: 'last_name' },
                {
                    key: 'is_blacklisted',
                    label: this.$translate('blocked'),
                    formatter: value => (value == 1 ? 'Yes' : 'No'),
                },
                {
                    key: 'email',
                    label: this.$translate('email'),
                    formatter: value =>
                        (value || '').indexOf(dummyEmailSuffix) >= 0
                            ? ''
                            : value,
                },
                {
                    key: 'position',
                    label: this.$translate('position')
                       
                },
                { label: this.$translate('phone'), key: 'phone' },
                {
                    key: 'notification',
                    label: this.$translate('notifications'),
                    formatter: value => (value == 1 ? 'On' : 'Off'),
                },
            ]
        },
        dummyEmailSuffix() {
            console.log('emailPartsValue:', this.emailPartsValue)
            const { emailDomain, usernameSuffix } = {
                ...(this.emailPartsValue || {}),
            }
            return `-${usernameSuffix}@${emailDomain}`
        },

        emailPartsValue() {
            return this.$store.getters['company/emailPartsValue']
        },

        emailPartsKey() {
            return this.$store.state.company.settingKeys.emailPartsKey
        },

        contacts() {
            return this.$store.getters['customers/customerUsers']
        },
        customer() {
            const customer = this.$store.state.customers.item
            if (customer == null) {
                return ''
            } else {
                return customer
            }
        },
        dobCalender(){
            //return moment().format('YYYY-MM-DD')
            return moment().subtract(18, 'years').format('YYYY-MM-DD')
        },
        isDummyEmail() {
            return (
                (this.userModel.email || '').indexOf(this.dummyEmailSuffix) >= 0
            )
        },
        displayEmail: {
            set(value) {
                this.$set(this.userModel, 'email', value)
            },
            get() {
                const {
                    isDummyEmail,
                    userModel: { email },
                    isEmailViewOnly,
                } = this
                return isDummyEmail && isEmailViewOnly
                    ? ''
                    : isDummyEmail
                        ? '------'
                        : email
            },
        },
        is_blacklisted: {
            set(value) {
                this.$set(this.userModel, 'is_blacklisted', value ? 1 : 0)
            },
            get() {
                return this.isDummyEmail
                    ? true
                    : !!this.userModel.is_blacklisted
            },
        },
        notification: {
            set(value) {
                this.$set(this.userModel, 'notification', value ? 1 : 0)
            },
            get() {
                return !!this.userModel.notification
            },
        },
        min_password_length() {
            return this.$minPasswordLength ? this.$minPasswordLength : 8;
        },
    },

    mounted() {
        this.$store.dispatch('company/fetchConfiguration', this.emailPartsKey)
        this.$root.$on('bv::modal::show', () => {
            this.isEmailViewOnly = false
            this.isPasswordViewOnly = false
        })
    },
    watch: {
        customer: {
            immediate: true,
            handler: function (val) {
                console.log("valuuuuuuuuu", val)
            },
            deep: true,
        },
    },

    methods: {
        viewCustomer(data) {
            this.userModel = { ...userModel, ...(data || {}) }
            this.$bvModal.show('modal-customer-user')
        },

        checkFormValidity() {
            const valid = this.$refs.contactForm.checkValidity()
            return valid
        },

        handleOk(bvModalEvent) {
            // Prevent modal from closing
            bvModalEvent.preventDefault()
            // Trigger submit handler
            ///this.handleSubmit()
            this.$refs.contactForm.requestSubmit()
        },

        async handleSubmit() {
            try {
                if (!this.checkFormValidity()) {
                    throw new Error(this.$translate('not_validated'))
                }
                const {
                    customer: { id: customer_id },
                    userModel: data,
                    isDummyEmail,
                    isEmailViewOnly,
                } = this
                const isNew = !data.id

                if (isEmailViewOnly) {
                    const { id: userId, email } = data
                    this.loading = true
                    await this.$store.dispatch('users/updateEmail', {
                        userId,
                        email,
                    })
                    await this.$store.dispatch(
                        'customers/fetchById',
                        customer_id
                    )
                } else {
                    if (isDummyEmail) {
                        data.is_blacklisted = 1
                    }

                    console.log('data', data)
                    if (data.is_blacklisted && !data.email) {
                        data.email = this.calculateDummyEmailAddress()
                    }
                    const path = `customers/${isNew ? 'createUser' : 'updateUser'
                        }`
                    this.loading = true
                    await this.$store.dispatch(path, {
                        customer_id,
                        data,
                    })
                }

                if (isNew) {
                    this.doToast(this.$translate('contact_created'), this.$translate('created'), 'success')
                } else {
                    this.doToast(this.$translate('contact_updated'), this.$translate('updated'), 'success')
                }

                this.$nextTick(() => {
                    this.$bvModal.hide('modal-customer-user')
                })
            } catch (error) {
                const emailError = 'The given data was invalid.'
                if (error.response) {
                    // Request made and server responded
                    console.log('error.response')
                    console.log(error.response.data)
                    console.log(error.response.status)
                    console.log(error.response.headers)
                    this.doToast(
                        this.$translate('error'),
                        error.response.data.message,
                        'danger'
                    )
                } else if (error.request) {
                    // The request was made but no response was received
                    console.log('error.request')
                    console.log(error.request)
                    this.doToast(
                        this.$translate('system_error_detected'),
                        this.$translate('contact_administrator'),
                        'danger'
                    )
                } else {
                    // Something happened in setting up the request that triggered an Error
                    let errorMessage = error.message

                    if (errorMessage == emailError) {
                        errorMessage = this.$translate('email_already_used')
                    }
                    console.log('Error', error.message)
                    this.doToast(this.$translate('error'), errorMessage, 'danger')
                }
            } finally {
                this.loading = false
            }
        },
        async updatePassword() {
            
            console.log("CustomerProfile", this.model)
            try {
                this.loading = true
                const {
                    userModel: data,
                    reset_password : password
                } = this
                const { id: userId } = data
                await this.$store.dispatch('users/updatePassword', {
                    password,
                    userId
                })
              
               
                this.doToast(this.$translate('contact_updated'), this.$translate('password_reseted'), 'success')
        

                this.$nextTick(() => {
                    this.$bvModal.hide('modal-customer-user')
                })
                this.loading = false
            
            } catch (error) {
                this.doToast(this.$translate('error'), error.response ? error.response.data.error.message.password ? error.response.data.error.message.password[0] : error.response.data.error.message.password : error.message, 'danger')
            } finally {
                this.loading = false
            }
        },
  
        calculateDummyEmailAddress() {
            const username =
                Math.random().toString(36).substring(2, 15) +
                Math.random().toString(36).substring(2, 15)
            return `${username}-${this.dummyEmailSuffix}`
        },

        async deleteUser(user_id) {
            try {
                const title = this.$translate('delete_customer_note');
                const message = `${this.$translate('delete_note')} ${this.$translate('contact')}?`
                const result = await this.confirmMessage(title, message)
                if (!result) throw new Error(this.$translate('cancel_delete'))

                const {
                    customer: { id: customer_id },
                } = this
                this.loading = true
                await this.$store.dispatch('customers/deleteUser', {
                    customer_id,
                    user_id,
                })
                this.doToast(this.$translate('contact_deleted'), this.$translate('deleted'), 'success')
                this.$bvModal.hide('modal-customer-user')
            } catch (err) {
                console.log('err', err)
                this.doToast(this.$translate('error'), err.message, 'danger')
            } finally {
                this.loading = false
            }
        },
        validatePassword() {
            // Check for uppercase letter
            this.hasNumber = /[0-9]/.test(this.reset_password);

            this.hasUppercase = /[A-Z]/.test(this.reset_password);
            
            // Check for lowercase letter
            this.hasLowercase = /[a-z]/.test(this.reset_password);
            
            // Check for special character
            this.hasSpecialCharacter = /[$@$!%*?&]/.test(this.reset_password);
        }
    },
}
</script>
